import { HttpClient } from '@angular/common/http';
import { Component, ViewChild, AfterViewInit, inject } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule, SortDirection } from '@angular/material/sort';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule, DatePipe } from '@angular/common';
import { CommentService } from '../../../services/comment.service';
import { Comment } from '../../../model/Comments';
import { DeviceDetectorService } from '../../../services/device-detector.service';
import { DialogService } from '../../../services/dialog.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-books',
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatSortModule, MatPaginatorModule, MatSelectModule, ReactiveFormsModule, MatIconModule],
  templateUrl: './books.component.html',
  styleUrl: './books.component.scss'
})
export class BooksComponent {

  
  displayedColumns: string[] = ['_id', 'book', 'actions'];
  data: Comment[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  filtrosForm: FormGroup;
  isFilteresOpened: boolean = true;

  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator();
  @ViewChild(MatSort) sort: MatSort = new MatSort();

  constructor(private service: CommentService, private deviceService: DeviceDetectorService, private dialogService: DialogService, fb: FormBuilder) {
    this.filtrosForm = fb.group({
      estado: ['no-leido'],
      reason: ['all']
    });
  }

  ngOnInit() {
    if (this.deviceService.isMobile()) {
      this.displayedColumns = ['_id', 'book', 'actions'];
    }
    this.isFilteresOpened = true;
  }

  ngAfterViewInit() {

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.service!.getComments(this.getParams())
            .pipe(catchError(() => observableOf(null)));
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = data === null;

          if (data === null) {
            return [];
          }

          this.resultsLength = data.total_count;
          return data.items;
        }),
      )
      .subscribe(data => (this.data = data));
  }

  clickAbrirCerrarFiltros() {
    this.isFilteresOpened = !this.isFilteresOpened;
  }

  buscar() {
    this.service!.getComments(this.getParams())
      .subscribe((data) => {
        this.data = data.items;
        this.resultsLength = data.total_count;
      });
  }

  getParams(): { estado: string, reason: string, page: number } {
    let obj: any = {
      estado: this.filtrosForm.value.estado,
      reason: this.filtrosForm.value.reason === 'all' ? undefined : this.filtrosForm.value.reason,
      page: this.paginator.pageIndex + 1
    };
    Object.keys(obj).forEach(key => obj[key] === undefined ? delete obj[key] : {});
    return obj;
  }

  esEstadoNoLeido(row: Comment): any {
    return row.status === 'no-leido';
  }

  marcarLeido(comment: Comment) {
    this.dialogService.confirm({
      title: 'Marcar como leído',
      message: '¿Estás seguro que quieres marcarlo como leido?',
      confirmText: 'Sí',
      cancelText: 'Cancelar'
    }).subscribe(result => {
      if (result) {
        this.service.actualizarComentario(comment).subscribe({
          next: (data) => {
            console.log(data);
            this.service.getComments(this.getParams())
              .subscribe({
                next: (data) => {
                  this.resultsLength = data.total_count;
                  this.data = data.items;
                }
              });
          }
        });
      }
    });
  }
}
